import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../models/tree-models';
import { safeJsonParse } from '@ebw-monorepo/microservices-helpers/utils/parser';

@Component({
  selector: 'app-fs-tree',
  templateUrl: './filesystem-tree.component.html',
  styleUrls: ['./filesystem-tree.component.scss']
})
export class FilesystemTreeComponent {
  @Input() nodes: TreeNode[] = [];
  @Output() nodesHandler: EventEmitter<TreeNode> = new EventEmitter<TreeNode>();
  @Output() dropHandler = new EventEmitter<any>();

  nodesEmitter = (node: TreeNode) => this.nodesHandler.emit(node);

  onDrop = (event) => {
    const { node: $event, elementDroped } = event;
    const node: TreeNode = safeJsonParse($event.dataTransfer.getData('node'));
    if (!node) {
      return;
    }
    const newFolder = elementDroped.textContent.trim();
    const body = { node, newFolder };
    this.dropHandler.emit(body);
  };
}
